<template>
    <svg class="svg-icon" height="16px" width="16px">
        <use :xlink:href="'#'+name" />
    </svg>
</template>
<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            }
        }
    }
</script>
<style lang="scss" scoped>
    .svg-icon {
        max-height: 100%;
        display: inline-block;
        font-size: 0;
    }
</style>